// extracted by mini-css-extract-plugin
export default {"data":"style_data__7P8id","contactUs":"style_contactUs__QOLNy"};